import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class SellerInvoiceService {

  constructor(private http: Http, private router: Router) { }

  public createInvoice(invData) {
    console.log('inside services');
    const poId = localStorage.getItem('sellerPoId');
    const buyerId = sessionStorage.getItem('poBuyerId');
    const data = {
      'buyerId': buyerId,
      'gst': 1,
      // 'gstNumber': '',
      'invoiceToAddress': invData.invoiceToAddress,
      'poId': poId,
      'shippingToAddress': invData.shippingAddr,
      'tanNumber': ''
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/seller/invoice', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public listInvoice() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/seller/invoice', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public filterInvoice(sellerInvID: any) {
    console.log('inside services');
    const invoiceId = sellerInvID;
    const sellerId = sessionStorage.getItem('sellerId');
    return this.http.get(environment.baseUrl + '/seller/invoice/' + sellerId + '/' + invoiceId,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterInvoiceGenerated(sellerInvID: any) {
    console.log('inside services');
    const invoiceId = sellerInvID;
    console.log('invoiceId', invoiceId);
    const sellerId = sessionStorage.getItem('generateBOESellerId');
    return this.http.get(environment.baseUrl + '/seller/invoice/' + sellerId + '/' + invoiceId,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public OnListBanks() {
    console.log('inside get all banks');
    return this.http.get(environment.baseUrl + '/user/list_of_banks').map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      console.log(user);
      return user;
    });
  }

  public OnMIOthersUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('MIOtherCustomerId');
    const manualInvoiceFlag = sessionStorage.getItem('MIOtherinvoiceFlag');
    const formData: FormData = new FormData();
    formData.append('others', Image);
    formData.append('invoiceId', fileId);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post(environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public OnOthersUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('sellerOtherCustomerId');
    const manualInvoiceFlag = sessionStorage.getItem('sellerOtherinvoiceFlag');
    const formData: FormData = new FormData();
    formData.append('others', Image);
    formData.append('invoiceId', fileId);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post(environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public paginationCI(newOffset, limit) {
    console.log('pagination', newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public previousPage(previousUrl) {
    console.log('on previous page', previousUrl);
    return this.http.get(environment.baseUrl + '/seller/invoice' + previousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public NextPage(nextUrl, newOffset, limit) {
    console.log('on next page', nextUrl, newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterCIByURL(offset: any, limit: any) {
    console.log('href on services', offset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice', {
      headers: headers, params: {
        offset: offset,
        limit: limit
      }
    })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public paginationMI(newOffset, MIlimit) {
    console.log('pagination', newOffset, MIlimit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: MIlimit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public MIpreviousPage(MIpreviousUrl) {
    console.log('on previous page', MIpreviousUrl);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual' + MIpreviousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public MINextPage(MInextUrl, MInewOffset, MIlimit) {
    console.log('on next page', MInextUrl, MInewOffset, MIlimit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual',
      {
        headers: headers, params: {
          offset: MInewOffset,
          limit: MIlimit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterMIByURL(MIoffset: any, MIlimit: any) {
    console.log('href on services', MIoffset, MIlimit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual', {
      headers: headers, params: {
        offset: MIoffset,
        limit: MIlimit
      }
    })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }



  public filterMIOffset() {
    console.log('offset');
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual',
      {
        headers: headers, params: {
          offset: '0',
          limit: '10'
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }



  public searchMI(search) {
    console.log('search', search.searchParam);
    console.log('offset', search.offsteParam);
    console.log('limit', search.limitParam);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice/manual',
      {
        headers: headers, params: {
          offset: 0,
          limit: search.limitParam,
          search: search.searchParam
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public searchCI(search) {
    console.log('search', search.searchParam);
    console.log('offset', search.offsteParam);
    console.log('limit', search.limitParam);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice',
      {
        headers: headers, params: {
          offset: 0,
          limit: search.limitParam,
          search: search.searchParam
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterCIOffset() {
    console.log('offset');
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/seller/invoice',
      {
        headers: headers, params: {
          offset: '0',
          limit: '10'
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public manualInvoicePayment(payload: { invoiceId: string, amount: string, orderId: string, sellerId: string }) {
		console.log("[BuyerInvoiceService manualInvoicePayment] payload", payload);
		
		const body = JSON.stringify(payload);
		
		return this.http.post(
			environment.baseUrl + "/seller/manual_invoice_payment",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService manualInvoicePayment] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService manualInvoicePayment] error", error);
				return Observable.throw(err);
			});
	}

  public getManualInvoiceStatus(payload: { invoiceId: string, amount: string, currency: string, sellerId: string }) {
		const body = JSON.stringify(payload);

		return this.http.post(
			environment.baseUrl + "/seller/manual_invoice_status",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService getManualInvoiceStatus] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService getManualInvoiceStatus] error", error);
				return Observable.throw(err);
			});
	}

  public  manualExcelUpload(Image) {
    console.log('image', Image);
    const form = new FormData();
    form.append('file', Image);
    return this.http.post(environment.baseUrl + '/user/manual_invoice_excel_upload', form, GlobalService.getInvHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

}

